import * as yup from "yup";

const banDriverValidator = yup
  .object({ reason: yup.string().required("Reason is required") })
  .required();

export default banDriverValidator;
